<script>
import {ref, onMounted, onBeforeUnmount} from "vue";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";


export default {
  name: 'MyOrders',
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let unit_name = ref('unit_name')

    let loading = ref(false)

    let cancel_alert = ref(false)

    let page_select = ref('active')

    let active_orders = ref([])
    let send_orders = ref([])
    let completed_orders = ref([])

    let order_id = ref(null)

    const update_orders = ref(null)

    onMounted(() => {
      update_orders.value = setInterval(() => {
        FreeWorld.Heisenberg({} , 'order_status' , true).then((result) => {

          loading.value = false
          var res = result.data
          active_orders.value = res.active
          send_orders.value = res.sending
          completed_orders.value = res.done
          console.log('RefreshPage = ok')

        }).catch(() => {
          console.log('RefreshPage = error')
        })
      }, 30000)
    })

    onBeforeUnmount(() => {
      clearInterval(update_orders.value)
    })


    function load_orders() {
      loading.value = true
      FreeWorld.Heisenberg({} , 'order_status' , true).then((result) => {

        loading.value = false
        var res = result.data
        active_orders.value = res.active
        send_orders.value = res.sending
        completed_orders.value = res.done

      }).catch((result) => {
        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_orders()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_orders()
            }
          })
        }
      })
    }
    load_orders()


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });


    function select_page(action) {

      if (action == 'active') {
        page_select.value = 'active'
      }

      if (action == 'send') {
        page_select.value = 'send'
      }

      if (action == 'complated') {
        page_select.value = 'complated'
      }

    }

    function alert_canceled() {
      // cancel_alert.value = true
      Swal.fire({
        html: `
        <div class="bg-white rounded-4 p-4 position-relative max_width">
          <p class="font-4 mb-3 text-center">
            علت لغو سفارشتان چیست؟
          </p>
          <div class="d-flex align-items-center">
            <input v-model="action_canceled" value="موجودی کافی نبود" id="cancel_1" type="radio" name="1">
            <label class="font-5 mx-1" for="cancel_1">
              موجودی کافی نبود
            </label>
          </div>
          <br>
          <div class="d-flex align-items-center">
            <input v-model="action_canceled" value="از فروشگاه دیگری محصول را تهیه کردم" id="cancel_2" type="radio" name="1">
            <label class="font-5 mx-1" for="cancel_2">
              از فروشگاه دیگری محصول را تهیه کردم
            </label>
          </div>
          <br>
          <div class="d-flex align-items-center">
            <input v-model="action_canceled" value="قیمت بالای محصول" id="cancel_3" type="radio" name="1">
            <label class="font-5 mx-1" for="cancel_3">
              قیمت بالای محصول
            </label>
          </div>
          <br>
          <div class="d-flex align-items-center">
            <input v-model="action_canceled" value="سایر موارد" id="cancel_4" checked type="radio" name="1">
            <label class="font-5 mx-1" for="cancel_4">
              سایر موارد
            </label>
          </div>
        </div>
          `,
        confirmButtonColor: '#FF9900',
        confirmButtonText: 'لغو نهایی',
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {
        if (result.isConfirmed) {

          canceling_orders()

        }
      })


    }

    function canceling_orders() {

      let action_canceled = document.querySelector("input[name='1']:checked ").value

      Swal.fire({
        title: 'سفارش را لغو میکنید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'بله, لغو میکنم',
        cancelButtonText: '!منصرف شدم',
        showClass: {
          popup: 'animate__animated animate__bounceInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__bounceOutUp'
        }
      }).then((result) => {
        if (result.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({order_id: order_id.value,cansel_type: 'user',cancel_reason: action_canceled,} , 'cansel_order').then((result) => {

            loading.value = false
            var res = result.data
            if (res.status == "ok") {

              Swal.fire({
                position: 'center-center',
                icon: 'success',
                title: 'محصول با موفقیت لغو شد',
                showConfirmButton: false,
                timer: 1500
              })
              load_orders()

            } else {

              Swal.fire({
                position: 'center-center',
                icon: 'error',
                title: 'متاسفانه محصول لغو نشد',
                showConfirmButton: false,
                timer: 1500

              })
            }

          }).catch(() => {

            loading.value = false
            if (result.message == 'Network Error') {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'تلاش مجدد',
                text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
              })

            } else {
              Swal.fire({
                icon: 'error',
                confirmButtonText: 'تلاش مجدد',
                text: '!خطای ارتباط با سرور',
              })
            }
          })
        }
      })

    }


    return {

      select_page,
      alert_canceled,
      cancel_alert,
      active_orders,
      send_orders,
      completed_orders,
      loading,
      unit_name,
      page_select,
      order_id,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass':''" class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0">
          مدیریت سفارشات
        </p>
        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="list_saver d-flex bg-main justify-content-between p-body max_width py-3">
      <v-btn @click="page_select = 'active'" :class="page_select === 'active' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 font-6 h-75 rounded-3 border-costom text-white ">
        سفارشات فعال
      </v-btn>

      <v-btn @click="page_select = 'send'" :class="page_select === 'send' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-75 font-6 rounded-3 border-costom text-white ">
        سفارشات در حال ارسال
      </v-btn>

      <v-btn @click="page_select = 'complated'" :class="page_select === 'complated' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-75 font-6 rounded-3 border-costom text-white ">
        سفارشات تکمیل شده
      </v-btn>
    </div>


    <div v-if="page_select === 'active' " id="main" :class="load_page ? 'activeClass' : '' " class="bg-main">
      <br>
      <br>
      <br>

      <div v-if="active_orders.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-4 ">
            ...شما درحال حاضر سفارش فعالی ندارید
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body">
        <!-- == -->
        <div v-for="item in active_orders" :key="item.id"
             class="animate__animated animate__fadeIn holder-element-order shadow-costom my-4 position-relative">
          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <p class="m-0 font-5 w-60 ml-2 text-end">{{ item.unit_name }}</p>

            <p :style="item.status == 1 ? 'background-color: #FF8F67' : 'background-color: #00F593' "
               class="m-0 text-condition-cancellation text-white text-center rounded-3 p-2 font-6">{{ item.message }}</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.time }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.day }}</p>
            </div>
            <p class="font-5 m-0">تاریخ سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between">
            <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
            <p class="font-5 m-0">کد رهگیری</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">مبلغ کل سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">کد تخفیف</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p v-if="item.installer == 1" class="font-5 m-0">بلی</p>
              <p v-else class="font-5 m-0">خیر</p>
            </div>
            <p class="font-5 m-0">نصاب</p>
          </div>
          <hr class="hr-order  bg-color">
          <p class="font-4 text-end">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
              <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                  <span>عدد</span>
                  &nbsp;
                  <span>{{ prod.count }}</span>
                </p>
              </div>

              <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                <img v-if="prod.pic1 !== null" class="img-food-order img-cover w-100 rounded-3" :src="prod.pic1" alt="">
                <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
              </div>
            </div>

          </div>

          <hr class="hr-order bg-color">
          <div v-if="item.status == 1" class="d-flex justify-content-center align-items-center">
            <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}" class="w-30">
              <v-btn @click="alert_canceled" class="font-5 rounded-3 bg-info text-white shadow h-100 py-3 w-100">جزییات
              </v-btn>
            </router-link>
            <v-btn @click="alert_canceled(item.id)" class="font-5 rounded-3 bg-danger text-white shadow mx-2 h-100 py-3 w-30">لغو
              سفارش
            </v-btn>

            <v-btn @click="accepting_orders(item.id)"
                   class="font-5 text-white bg-success rounded-3 shadow h-100 py-3 w-30">قبول
              سفارش
            </v-btn>
          </div>
          <div v-else class="d-flex justify-content-center align-items-center justify-content-evenly">
            <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}" class="w-30">
              <v-btn @click="alert_canceled" class="font-5 rounded-3 bg-info text-white shadow h-100 py-3 w-100">جزییات
              </v-btn>
            </router-link>
            <v-btn @click="sending_orders(item.id)" class="font-4 text-black bg-yellow rounded-3 shadow h-100 mx-2 py-3">
              آماده برای ارسال
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="page_select === 'send' " id="main" :class="load_page ? 'activeClass' : '' " class="bg-main">
      <br>
      <br>
      <br>

      <div v-if="send_orders.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-4 ">
            ...شما درحال حاضر سفارش ارسال شده ای ندارید
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body">
        <!-- == -->
        <div v-for="item in send_orders" :key="item.id"
             class="animate__animated animate__fadeIn holder-element-order shadow-costom my-4 position-relative">
          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <p class="m-0 text-end w-60 ml-2 font-5">{{ item.unit_name }}</p>

            <p :style="item.status == 3 ? 'background-color: #EFFF00' : 'background-color: #FF3C00' "
               class="m-0 text-condition-cancellation text-black text-center rounded-3 p-2 font-6">{{ item.message }}</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.time }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.day }}</p>
            </div>
            <p class="font-5 m-0">تاریخ سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between">
            <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
            <p class="font-5 m-0">کد رهگیری</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">مبلغ کل سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">کد تخفیف</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p v-if="item.installer == 1" class="font-5 m-0">بلی</p>
              <p v-else class="font-5 m-0">خیر</p>
            </div>
            <p class="font-5 m-0">نصاب</p>
          </div>
          <hr class="hr-order  bg-color">
          <p class="font-4 text-end">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
              <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                  <span>عدد</span>
                  &nbsp;
                  <span>{{ prod.count }}</span>
                </p>
              </div>

              <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                <img v-if="prod.pic1 !== null" class="img-food-order img-cover w-100 rounded-3" :src="prod.pic1" alt="">
                <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
              </div>
            </div>

          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-center align-items-center justify-content-evenly">
            <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}" class="w-30">
              <v-btn @click="alert_canceled" class="font-5 rounded-3 bg-info text-white shadow mx-2 h-100 py-3 w-100">
                جزییات
              </v-btn>
            </router-link>

            <v-btn @click="done_orders(item.id)" class="font-4 text-white bg-color rounded-3 shadow py-3 h-100">
              تکمیل سفارش
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="page_select === 'complated' " id="main" :class="load_page ? 'activeClass' : '' " class="bg-main">
      <br>
      <br>
      <br>

      <div v-if="completed_orders.length == 0"
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
          <br>
          <p class="font-4 ">
            ...شما درحال حاضر سفارش تکمیل شده ای ندارید
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body">
        <!-- == -->
        <div v-for="item in completed_orders" :key="item.id"
             class="animate__animated animate__fadeIn holder-element-order shadow-costom my-4 position-relative">
          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <p class="m-0 ml-2 w-60 text-end font-5">{{ item.unit_name }}</p>

            <p :style="item.status == 4 ? 'background-color: #FF6F00' : 'background-color: #FF3C00' "
               class="m-0 text-condition-cancellation text-white text-center rounded-3 p-2 font-6">{{ item.message }}</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.time }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.day }}</p>
            </div>
            <p class="font-5 m-0">تاریخ سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between">
            <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
            <p class="font-5 m-0">کد رهگیری</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">مبلغ کل سفارش</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p class="font-5 m-0">تومان</p>
              &nbsp;
              <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
            </div>
            <p class="font-5 m-0">کد تخفیف</p>
          </div>
          <hr class="hr-order  bg-color">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex ">
              <p v-if="item.installer == 1" class="font-5 m-0">بلی</p>
              <p v-else class="font-5 m-0">خیر</p>
            </div>
            <p class="font-5 m-0">نصاب</p>
          </div>
          <hr class="hr-order  bg-color">
          <p class="font-4 text-end">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
              <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                  <span>عدد</span>
                  &nbsp;
                  <span>{{ prod.count }}</span>
                </p>
              </div>

              <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                <img v-if="prod.pic1 !== null" class="img-food-order img-cover w-100 rounded-3" :src="prod.pic1" alt="">
                <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
              </div>
            </div>

          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-center align-items-center">
            <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}" class="w-30">
              <v-btn @click="alert_canceled" class="font-5 rounded-3 bg-info text-white shadow mx-2 h-100 py-3 w-100">
                جزییات
              </v-btn>
            </router-link>
          </div>

        </div>
      </div>
    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass':''" class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">سفارشات من</div>

    <div class="p-4 w-75 bg-white rounded-4 m-auto">

      <div class="list_saver-web mb-2 d-flex justify-content-between">
        <v-btn @click="page_select = 'active'" :class="page_select === 'active' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver-web w-30 p-2 font-6 h-75 rounded-3 border-costom text-white ">
          سفارشات فعال
        </v-btn>

        <v-btn @click="page_select = 'send'" :class="page_select === 'send' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver-web w-30 p-2 h-75 font-6 rounded-3 border-costom text-white ">
          سفارشات در حال ارسال
        </v-btn>

        <v-btn @click="page_select = 'complated'" :class="page_select === 'complated' ? 'bg-color' : 'bg-unavailable' "
               class="title_saver-web w-30 p-2 h-75 font-6 rounded-3 border-costom text-white ">
          سفارشات تکمیل شده
        </v-btn>
      </div>


      <div dir="ltr" v-if="page_select === 'active' ">

        <div v-if="active_orders.length === 0 " class="w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-4 ">
              ...شما درحال حاضر سفارش فعالی ندارید
            </p>
          </div>
        </div>

        <div v-else style="height: 60vh" class="mt-2 p-body overflow-y-scroll animate__animated animate__fadeIn">
          <!-- == -->
          <div v-for="item in active_orders" :key="item.id"
               class="holder-element-order shadow-costom my-4 position-relative">

            <!--        <img style="width: 30px; height: 30px; top: 7px; right: 7px" class="position-absolute" src="../assets/img/info-orders.png" alt="">-->

            <div class="d-flex align-items-center justify-content-between flex-row-reverse">
              <p class="m-0 font-5 w-60 ml-2 text-end">{{ item.unit_name }}</p>

              <p :style="item.status == 1 ? 'background-color: #FF8F67' : 'background-color: #00F593' "
                 class="m-0 text-condition-cancellation text-white text-center rounded-3 p-2 font-6">{{
                  item.message
                }}</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="data-left d-flex justify-content-center">
                <p class="font-5 m-0">{{ item.time }}</p>
                <p class="font-5 m-0 mx-3">{{ item.date }}</p>
                <p class="font-5 m-0">{{ item.day }}</p>
              </div>
              <p class="font-5 m-0">تاریخ سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between">
              <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
              <p class="font-5 m-0">کد رهگیری</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">مبلغ کل سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex ">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">کد تخفیف</p>
            </div>

            <hr class="hr-order  bg-color">

            <p class="font-4 text-end">
              اقلام سفارش
            </p>

            <div id="list_orders" class="holder-img-food">

              <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
                <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                  <div class="overflow-hidden">
                    <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                  </div>

                  <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                    <span>عدد</span>
                    &nbsp;
                    <span>{{ prod.count }}</span>
                  </p>
                </div>

                <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                  <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                  <img v-if="prod.pic1 !== null" class="img-food-order w-100 img-cover rounded-3" :src="prod.pic1" alt="">
                  <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
                </div>
              </div>

            </div>

            <hr class="hr-order bg-color">

            <div class="d-flex justify-content-center align-items-center animate__animated animate__fadeInDown">

              <v-btn v-if="item.status == 1" @click="order_id = item.id ; alert_canceled()"
                     class="font-4 h-100 text-white rounded-3 w-45 p-2 bg-danger shadow mx-2">لغو سفارش
              </v-btn>

              <v-btn class="font-4 rounded-3 border-0 p-2 bg-info w-45 h-100 shadow mx-2">
                <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}"
                             class="text-white text-decoration-none">
                  جزییات سفارش
                </router-link>
              </v-btn>

            </div>
          </div>


        </div>

      </div>

      <div dir="ltr" v-if="page_select === 'send' ">

        <div v-if="send_orders.length === 0"
             class="w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-4 ">
              ...شما درحال حاضر سفارش فعالی ندارید
            </p>
          </div>
        </div>

        <div v-else style="height: 60vh"  class="mt-2 p-body overflow-y-scroll animate__animated animate__fadeIn">
          <!-- == -->
          <div v-for="item in send_orders" :key="item.id"
               class="holder-element-order shadow-costom my-4 position-relative">
            <div class="d-flex align-items-center justify-content-between flex-row-reverse">
              <p class="m-0 text-end w-60 ml-2 font-5">{{ item.unit_name }}</p>

              <p :style="item.status == 3 ? 'background-color: #EFFF00' : 'background-color: #FF3C00' "
                 class="m-0 text-condition-cancellation text-black text-center rounded-3 p-2 font-6">{{
                  item.message
                }}</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="data-left d-flex justify-content-center">
                <p class="font-5 m-0">{{ item.time }}</p>
                <p class="font-5 m-0 mx-3">{{ item.date }}</p>
                <p class="font-5 m-0">{{ item.day }}</p>
              </div>
              <p class="font-5 m-0">تاریخ سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between">
              <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
              <p class="font-5 m-0">کد رهگیری</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">مبلغ کل سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex ">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">کد تخفیف</p>
            </div>

            <hr class="hr-order  bg-color">

            <p class="font-4 text-end">
              اقلام سفارش
            </p>

            <div id="list_orders" class="holder-img-food">

              <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
                <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                  <div class="overflow-hidden">
                    <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                  </div>

                  <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                    <span>عدد</span>
                    &nbsp;
                    <span>{{ prod.count }}</span>
                  </p>
                </div>

                <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                  <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                  <img v-if="prod.pic1 !== null" class="img-food-order img-cover w-100 rounded-3" :src="prod.pic1" alt="">
                  <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
                </div>
              </div>

            </div>

            <hr class="hr-order  bg-color">

            <div class="d-flex justify-content-center align-items-center animate__animated animate__fadeInDown">
              <v-btn class="font-4 rounded-3 border-0 p-2 bg-info w-45 h-100 shadow mx-2">
                <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}"
                             class="text-white text-decoration-none">
                  جزییات سفارش
                </router-link>
              </v-btn>
            </div>

          </div>
        </div>
      </div>

      <div dir="ltr" v-if="page_select === 'complated'">

        <div v-if="completed_orders.length === 0"
             class="w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
          <div class="d-flex flex-column align-items-center">
            <img style="width: 70px" src="../assets/img/purchase-order-4.svg" alt="">
            <br>
            <p class="font-4 ">
              ...شما درحال حاضر سفارش فعالی ندارید
            </p>
          </div>
        </div>

        <div v-else style="height: 60vh"  class="mt-2 overflow-y-scroll p-body animate__animated animate__fadeIn">
          <!-- == -->
          <div v-for="item in completed_orders" :key="item.id"
               class="holder-element-order shadow-costom my-4 position-relative">
            <div class="d-flex align-items-center justify-content-between flex-row-reverse">
              <p class="m-0 ml-2 w-60 text-end font-5">{{ item.unit_name }}</p>

              <p :style="item.status == 4 ? 'background-color: #FF9900' : 'background-color: #FF3C00' "
                 class="m-0 text-condition-cancellation text-white text-center rounded-3 p-2 font-6">{{
                  item.message
                }}</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="data-left d-flex justify-content-center">
                <p class="font-5 m-0">{{ item.time }}</p>
                <p class="font-5 m-0 mx-3">{{ item.date }}</p>
                <p class="font-5 m-0">{{ item.day }}</p>
              </div>
              <p class="font-5 m-0">تاریخ سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between">
              <p class="font-5 m-0 tracking-Code">{{ item.ord_num }}</p>
              <p class="font-5 m-0">کد رهگیری</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.all_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">مبلغ کل سفارش</p>
            </div>
            <hr class="hr-order  bg-color">
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex ">
                <p class="font-5 m-0">تومان</p>
                &nbsp;
                <p class="font-5 m-0">{{ item.discount_price.toLocaleString() }}</p>
              </div>
              <p class="font-5 m-0">کد تخفیف</p>
            </div>

            <hr class="hr-order  bg-color">

            <p class="font-4 text-end">
              اقلام سفارش
            </p>

            <div id="list_orders" class="holder-img-food">

              <div v-for="prod in item.products" :key="prod.id" style="width: 11rem;min-width: 11rem" class="d-flex justify-content-between mx-1 animate__animated animate__fadeIn">
                <div class="mx-1 w-45 py-2 d-flex flex-column justify-content-between">
                  <div class="overflow-hidden">
                    <p :class="{'txtoverflow':prod.name.length >= 10}" class="font-5 m-0 text-end font-bold">{{prod.name}}</p>
                  </div>

                  <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                    <span>عدد</span>
                    &nbsp;
                    <span>{{ prod.count }}</span>
                  </p>
                </div>

                <div class="img-food-order w-66 animated-background rounded-3 position-relative overflow-hidden">
                  <p v-if="prod.installer > 0" class="py-1 font-bold px-5 installer m-0 bg-danger position-absolute font-6 text-white">نیاز به نصاب</p>
                  <img v-if="prod.pic1 !== null" class="img-food-order img-cover w-100 rounded-3" :src="prod.pic1" alt="">
                  <img v-else class="img-food-order w-100 rounded-3" src="../assets/img/img-notavalible.jpg" alt="">
                </div>
              </div>

            </div>

            <hr class="hr-order  bg-color">

            <div class="d-flex justify-content-center align-items-center animate__animated animate__fadeInDown">
              <v-btn class="font-4 rounded-3 border-0 p-2 bg-info w-45 h-100 shadow mx-2">
                <router-link :to="{name:'DetailsOrders' , params:{ord_id:item.id}}"
                             class="text-white text-decoration-none">
                  جزییات سفارش
                </router-link>
              </v-btn>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>

</template>

<style scoped>

.list_saver {
  width: 100%;
  direction: rtl;
  position: fixed;
  top: 65px;
  z-index: 1;
}
.title_saver {
  min-height: 50px;
}
.swall {
  width: 95%;
  direction: ltr;
}
/* === */
.holder-element-order {
  width: 100%;
  border-radius: 10px;
  padding: 20px 25px;
}
.text-condition-cancellation {
  background-color: #b6b6b6;
  padding: 5px 15px;
}
.hr-order {
  width: 100%;
  /* margin: 10px 0 !important; */
}
.holder-img-food {
  padding: 5px 0;
  overflow-x: scroll;
  display: flex;
}
.holder-img-food::-webkit-scrollbar {
  display: none;
}
.img-food-order {
  height: 6rem;
}


.list_saver-web {
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 1;
}
.title_saver-web {
  min-height: 50px;
  font-size: .8em !important;
}
.installer{
  transform: rotate(45deg);
  right: -3rem;
  top: 1rem;
  white-space: nowrap;
}
</style>